jQuery(document).ready(function ($) {
	function updateAddButtonText($container) {
		var $button = $container.find('.add-array-item');
		if (!$button.length) return;
		var $items = $container.children('.array-item');
		var count = $items.length;
		var templateCount = $container.find('.array-item-template .array-item').length;
		var label = $button.data('label');
		if (!label) {
			var current = ($button.text() || '').trim();
			label = current.replace(/^Add (another |a )?/i, '') || 'item';
			$button.data('label', label);
		}
		var startsWithVowel = /^[aeiou]/i.test(label.trim());
		var prefix = count > 0 ? 'Add another ' : 'Add ' + (startsWithVowel ? 'an ' : 'a ');
		$button.text('+ ' + prefix + label);
	}

	$('.array-fields').each(function () {
		updateAddButtonText($(this));
	});

	// Handle adding array items
	$(document).on('click', '.add-array-item', function () {
		var $container = $(this).closest('.array-fields');
		var $template = $container.find('.array-item-template .array-item').clone();
		$template.find('input, select, textarea').val('');
		$(this).before($template);
		updateAddButtonText($container);
	});

	// Handle removing array items
	$(document).on('click', '.remove-array-item', function () {
		var $container = $(this).closest('.array-fields');
		$(this).closest('.array-item').remove();
		updateAddButtonText($container);
	});
});
